import React from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";

import PropTypes from "prop-types";

class Forms extends React.Component {
    // constructor(props){
    //     super(props);

    //     // variant 값
    //     //
    //     // 'primary',
    //     // 'secondary',
    //     // 'success',
    //     // 'danger',
    //     // 'warning',
    //     // 'info',
    //     // 'light',
    //     // 'dark',
    // }

    clickButton = e => {
        this.props.onClick(e);
    };

    render() {
        return (
            // <OverlayTrigger overlay={<Tooltip>{this.props.title}</Tooltip>}>
            <Button variant={this.props.variant} disabled={this.props.disabled} onClick={this.clickButton} style={this.props.style}>
                {this.props.title}
            </Button>
            // </OverlayTrigger>
        );
    }
}

Forms.defaultProps = {
    title: "",
    variant: "primary",
    disabled: false
};

Forms.propTypes = {
    title: PropTypes.string,
    variant: PropTypes.string
};

export default Forms;
